(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('ecFileDrop', ecFileDrop)
        .directive('ecFileSelect', ecFileSelect);

    /**
     * File Drop Directive
     * Handles drag and drop file uploads without using angular.element().scope()
     * which doesn't work in production builds.
     *
     * Usage:
     * <div ec-file-drop
     *      on-drop="handleDrop($files)"
     *      on-drag-over="handleDragOver()"
     *      on-drag-leave="handleDragLeave()">
     * </div>
     */
    function ecFileDrop() {
        return {
            restrict: 'A',
            scope: {
                onDrop: '&',
                onDragOver: '&',
                onDragLeave: '&'
            },
            link: function (scope, element) {
                element.on('dragover', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (scope.onDragOver) {
                        scope.$apply(function () {
                            scope.onDragOver();
                        });
                    }
                });

                element.on('dragleave', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (scope.onDragLeave) {
                        scope.$apply(function () {
                            scope.onDragLeave();
                        });
                    }
                });

                element.on('drop', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var files = event.originalEvent ?
                        event.originalEvent.dataTransfer.files :
                        event.dataTransfer.files;

                    if (scope.onDrop && files.length > 0) {
                        scope.$apply(function () {
                            scope.onDrop({ $files: files });
                        });
                    }
                });

                // Cleanup
                scope.$on('$destroy', function () {
                    element.off('dragover dragleave drop');
                });
            }
        };
    }

    /**
     * File Select Directive
     * Handles file input change events without using angular.element().scope()
     * which doesn't work in production builds.
     *
     * Usage:
     * <input type="file" ec-file-select on-select="handleFileSelect($files)">
     */
    function ecFileSelect() {
        return {
            restrict: 'A',
            scope: {
                onSelect: '&'
            },
            link: function (scope, element) {
                element.on('change', function (event) {
                    var files = event.target.files;

                    if (scope.onSelect && files && files.length > 0) {
                        scope.$apply(function () {
                            scope.onSelect({ $files: files });
                        });
                    }

                    // Reset input so same file can be selected again
                    element.val('');
                });

                // Cleanup
                scope.$on('$destroy', function () {
                    element.off('change');
                });
            }
        };
    }
})();
